import { DelegateComponent } from './main/delegate/delegate.component';
import { DelegateChildRoutes } from './main/delegate/delegate.routing';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { InfractionsComponent } from './main/infractions/infractions.component';
import { RecentActivitiesComponent } from './main/recent-activities/recent-activities.component';
import { EnterComponent } from './main/infractions/enter/enter.component';
import { TasksComponent } from './main/tasks/tasks.component';
import { LicenseChildRoutes } from './main/license/license.routing';
import { LicenseComponent } from './main/license/license.component';
import { TasksChildRoutes } from './main/tasks/tasks.routing';
import { InfractionEnterChildRoutes } from './main/infractions/enter/enter.routing';
import { SearchComponent } from './main/search/search.component';
import { SearchChildRoutes } from './main/search/search.routing';
import { AuthGuard } from '@/auth/guard/auth.guard';
import { RouteWithGuardData } from '@/auth/interface/auth.interface';
import { getDefinitionByPath } from '@/auth/routes/auth.routes';
import { ReportsComponent } from './main/reports/reports.component';
import { ReportsChildRoutes } from './main/reports/reports.routing';
import { VerificationComponent } from './main/verification/verification.component';
import { verificationHomeChildRoutes } from './main/verification/verification.routing';

export const ViewsChilRoutes: RouteWithGuardData[] = [
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'delegate',
    component: DelegateComponent,
    children: DelegateChildRoutes,

    canActivate: [AuthGuard],
    data: getDefinitionByPath('/delegate'),
  },
  {
    path: 'license',
    component: LicenseComponent,
    children: LicenseChildRoutes,
    // Route guards on LicenseChildRoutes
  },
  {
    path: 'recent-activities',
    component: RecentActivitiesComponent,
  },
  {
    path: 'tasks',
    component: TasksComponent,
    children: TasksChildRoutes,

    canActivate: [AuthGuard],
    data: getDefinitionByPath('/tasks'),
  },
  {
    path: 'verification',
    component: VerificationComponent,
    children: verificationHomeChildRoutes,
  },
  {
    path: 'infractions',
    component: InfractionsComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/infractions'),
    children: [
      {
        path: 'enter',
        component: EnterComponent,
        children: InfractionEnterChildRoutes,
      },
      {
        path: '',
        pathMatch: 'prefix',
        redirectTo: '/infractions/enter',
      },
    ],
  },
  {
    path: 'search',
    component: SearchComponent,
    children: SearchChildRoutes,
  },
  {
    path: 'reports',
    component: ReportsComponent,
    children: ReportsChildRoutes,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
